// Product Image Gallery - Mobile Native Scroll Snap Carousel

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var wrapper = document.querySelector('.mobile-gallery-wrapper');
    if (!wrapper) return;

    var slider = wrapper.querySelector('.mobile-gallery-slider');
    var slides = wrapper.querySelectorAll('.mobile-gallery-slide');
    var thumbs = wrapper.querySelectorAll('.mobile-gallery-thumb');
    var dots = wrapper.querySelectorAll('.mobile-gallery-dot');
    var arrowLeft = wrapper.querySelector('.mobile-gallery-arrow--left');
    var arrowRight = wrapper.querySelector('.mobile-gallery-arrow--right');
    var strip = wrapper.querySelector('.mobile-gallery-thumbnails');

    if (slides.length === 0) return;

    var currentIndex = -1;

    function getSlideWidth() {
      return slider.offsetWidth;
    }

    function updateActiveStates(index) {
      if (index === currentIndex) return;
      currentIndex = index;

      for (var i = 0; i < thumbs.length; i++) {
        thumbs[i].classList.toggle('active', i === currentIndex);
      }
      for (var j = 0; j < dots.length; j++) {
        dots[j].classList.toggle('active', j === currentIndex);
      }

      // Center active thumbnail in strip (horizontal only)
      if (thumbs[currentIndex] && strip) {
        var thumb = thumbs[currentIndex];
        var scrollTarget = thumb.offsetLeft - (strip.offsetWidth / 2) + (thumb.offsetWidth / 2);
        strip.scrollTo({ left: scrollTarget, behavior: 'smooth' });
      }
    }

    function scrollToSlide(index) {
      if (index < 0 || index >= slides.length) return;
      slider.scrollTo({ left: index * getSlideWidth(), behavior: 'smooth' });
    }

    // --- Detect current slide instantly via IntersectionObserver ---
    var observer = null;

    function initObserver() {
      if (observer) observer.disconnect();
      observer = new IntersectionObserver(function(entries) {
        for (var e = 0; e < entries.length; e++) {
          if (entries[e].isIntersecting) {
            var idx = parseInt(entries[e].target.getAttribute('data-slide-index'), 10);
            if (!isNaN(idx)) updateActiveStates(idx);
          }
        }
      }, {
        root: slider,
        threshold: 0.5
      });
      for (var s = 0; s < slides.length; s++) {
        observer.observe(slides[s]);
      }
    }

    for (var s = 0; s < slides.length; s++) {
      slides[s].setAttribute('data-slide-index', s);
    }
    initObserver();

    // Re-init observer when crossing desktop→mobile breakpoint
    window.matchMedia('(max-width: 949px)').addEventListener('change', function(e) {
      if (e.matches) initObserver();
    });

    // --- Arrows ---
    if (arrowLeft) {
      arrowLeft.addEventListener('click', function() { scrollToSlide(currentIndex - 1); });
    }
    if (arrowRight) {
      arrowRight.addEventListener('click', function() { scrollToSlide(currentIndex + 1); });
    }

    // --- Thumbnails ---
    for (var t = 0; t < thumbs.length; t++) {
      (function(idx) {
        thumbs[idx].addEventListener('click', function() { scrollToSlide(idx); });
      })(t);
    }

    // --- Dots ---
    for (var d = 0; d < dots.length; d++) {
      (function(idx) {
        dots[idx].addEventListener('click', function() { scrollToSlide(idx); });
      })(d);
    }

    // --- Init ---
    updateActiveStates(0);
  });
})();
